// Fallback backend URL if env is missing
const BACKEND_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8648/api').replace(/\/api\/$/, '').replace(/\/api$/, '');

/**
 * Sanitizes a URL by removing double slashes (except after the protocol).
 * Also prepends backend URL to relative paths (e.g. /storage/...).
 * Example: /storage/files/abc.png -> http://localhost:8648/storage/files/abc.png
 * 
 * @param {string} url The URL to sanitize
 * @returns {string} The sanitized URL
 */
export const sanitizeUrl = (url) => {
    if (!url || typeof url !== 'string') return url;

    // If it's a relative path starting with /, prepend backend URL
    if (url.startsWith('/')) {
        return `${BACKEND_URL}${url}`;
    }

    // Replace // with / unless it is preceded by a colon (like in http://)
    return url.replace(/([^:])\/\//g, '$1/');
};
